import { Box, Card, CardContent, Chip, Typography } from "@mui/material"
import type { ChatAnalyze } from "../interfaces"

interface KpiCardProps {
  title: string
  value: string
  subtitle: string
  color?: ChatAnalyze.BadgeColor
  hint?: string
}

const colorMap: Record<
  NonNullable<ChatAnalyze.BadgeColor>,
  "default" | "success" | "warning" | "error"
> = {
  success: "success",
  warning: "warning",
  error: "error",
  default: "default",
}

export function KpiCard({
  title,
  value,
  subtitle,
  color = "default",
  hint,
}: KpiCardProps) {
  return (
    <Card variant="outlined" sx={{ height: "100%" }}>
      <CardContent sx={{ textAlign: "center", py: 2 }}>
        <Typography
          variant="caption"
          color="text.secondary"
          display="block"
          sx={{ mb: 0.5, lineHeight: 1.3 }}
        >
          {title}
        </Typography>

        <Typography
          variant="h4"
          component="div"
          fontWeight={700}
          sx={{ mb: 0.5 }}
        >
          {value}
        </Typography>

        <Chip
          label={subtitle}
          size="small"
          color={colorMap[color]}
          sx={{ fontSize: "0.7rem", height: 20 }}
        />

        {hint && (
          <Box
            sx={{
              mt: 1,
              px: 1,
              py: 0.5,
              bgcolor: "action.hover",
              borderRadius: 1,
              borderLeft: "3px solid",
              borderColor: "info.main",
            }}
          >
            <Typography variant="caption" color="text.secondary">
              {hint}
            </Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  )
}
